// ModalJs.js
import React, { useState } from 'react';
import { Button, Modal, Collapse } from 'antd';

const ModalJs = ({
  props,
  title,
  customTitle,
  customBody,
  width: widthProp,
  bodyStyle: bodyStyleProp,
  modalStyle,
  hideFooter = false,
  destroyOnClose = true,
  onClose,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const data = props;

  // -- existing logic you had --
  const isRelevantClauses =
    Array.isArray(data) &&
    data[0]?.label?.props?.children?.[0]?.props?.children === 'Relevant Clauses';

  const isCopilot = customTitle === 'Contract Copilot';

  const defaultActiveKey = isRelevantClauses ? '6' : '1';
  const width = widthProp ?? (isRelevantClauses ? 1430 : 800);

  // keep your right-docked style for non-Copilot use cases
  const nonCopilotStyle = {
    right: 0,
    position: 'absolute',
    top: 0,
  };

  const divStyle = isRelevantClauses
    ? { maxHeight: '82vh' }
    : { maxHeight: '85vh', overflowY: 'auto' };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    onClose?.(); // callback to parent
  };

  const footer = hideFooter
    ? null
    : [
        <Button key="close" onClick={handleCloseModal}>
          Close
        </Button>,
      ];

  // Build modal props per mode (Copilot vs others)
  const modalCommonProps = {
    open: isModalOpen,
    onCancel: handleCloseModal,
    title,
    footer,
    destroyOnClose,
  };

  const copilotModalProps = isCopilot
    ? {
        // 🔧 key fixes for instant centering (no bottom flash)
        centered: true,
        getContainer: () => document.body,
        // Pre-render to avoid layout shift when Web Chat boots up
        forceRender: true,
        // Let AntD handle positioning; do not apply custom fixed style here
        style: modalStyle,
        bodyStyle: { padding: 0, ...(bodyStyleProp || {}) },
        width: widthProp ?? 980,
        maskClosable: false,
      }
    : {
        // ✅ keep your existing right-docked behaviour
        style: nonCopilotStyle,
        bodyStyle: bodyStyleProp,
        width,
        maskClosable: true,
      };

  return (
    <Modal {...modalCommonProps} {...copilotModalProps}>
      {customBody ? (
        customBody
      ) : (
        <div style={divStyle}>
          <Collapse
            defaultActiveKey={[defaultActiveKey]}
            items={Array.isArray(data) ? data : []}
            size="small"
          />
        </div>
      )}
    </Modal>
  );
};

export default ModalJs;